import { computed } from 'vue';
import { get } from 'lodash';

import useYardTaskEvent from './useYardTaskEvent';

import type { YardTaskTimelineEvent } from '../../composables/useYardTaskTimeline';
import type { UseYardTaskEventOptions } from './useYardTaskEvent';

/**
 * Composable for unassigned event that extends base event composable
 * @param {YardTaskTimelineEvent} event
 * @param {UseYardTaskEventOptions} options
 * @returns {Object} Base event data plus unassigned-specific data
 */
export default function useYardTaskUnassignedEvent(
  event: YardTaskTimelineEvent,
  options: UseYardTaskEventOptions
) {
  // Get base event data
  const baseEventData = useYardTaskEvent(event, options);

  // Extract unassigned-specific data
  const previousAssignedId = computed(() => {
    return get(event, 'data.data.previousAssigned') || null;
  });

  return {
    ...baseEventData,
    previousAssignedId
  };
}
